/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { get } from 'lodash';
import { stringify } from 'qs';
import axios from 'axios';

export const namespaced = true;

export const state = {
    jobs: [],
    count: {},
    page: {}
};

export const mutations = {
    POPULATE_JOBS(state, payload) {
        state.jobs = payload;
    },

    POPULATE_META(state, payload) {
        state.count = payload;
    },

    POPULATE_PAGEDATA(state, { current, total }) {
        state.page = {
            current: current || 1,
            total: total || 1,
        };
    }
};

export const actions = {
    async fetchJobs({ commit }, params) {
        const url = `/api/user/jobs.json?${stringify(params)}`;
        const response = await axios.get(url);

        // Set data with responses
        commit('POPULATE_JOBS', get(response, 'data.data.jobs', []));
        commit('POPULATE_META', get(response, 'data.data.count', {}));
        commit('POPULATE_PAGEDATA', {
            current: get(response, 'data.data.currentPage', 1),
            total: get(response, 'data.data.totalPages', 1),
        });

        return response.data.data;
    },
};

export const getters = {};

